import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7bd6774d"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "ARTISTS IN YOUR ACCOUNT")
], -1))
const _hoisted_2 = {
  key: 2,
  class: "info-container"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "info" }, " Move your Artists around by dragging and dropping them into your preferred order! ", -1))
const _hoisted_4 = { key: 4 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SpinnerLoader = _resolveComponent("SpinnerLoader")!
  const _component_ArtistPopup = _resolveComponent("ArtistPopup")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_InsideSearch = _resolveComponent("InsideSearch")!
  const _component_ArtistCard = _resolveComponent("ArtistCard")!
  const _component_Draggable = _resolveComponent("Draggable")!
  const _component_Container = _resolveComponent("Container")!
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!
  const _component_MainLayout = _resolveComponent("MainLayout")!

  return (_openBlock(), _createBlock(_component_MainLayout, null, {
    default: _withCtx(() => [
      (_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_SpinnerLoader, { key: 0 }))
        : (_openBlock(), _createBlock(_component_ArtistPopup, {
            key: 1,
            show: _ctx.show,
            onClose: _ctx.toggleShow,
            onAddArtist: _ctx.addArtist,
            artists: _ctx.allArtists,
            "gallery-artists": _ctx.artists
          }, null, 8, ["show", "onClose", "onAddArtist", "artists", "gallery-artists"])),
      _hoisted_1,
      _createVNode(_component_v_divider),
      _createVNode(_component_InsideSearch, {
        button: "Add Artist",
        onSearch: _ctx.filterArtists,
        onPopup: _ctx.toggleShow
      }, null, 8, ["onSearch", "onPopup"]),
      _createVNode(_component_v_divider),
      (!_ctx.isPrivateSeller)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("div", {
              style: {"cursor":"pointer"},
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.saveOrder && _ctx.saveOrder(...args)))
            }, [
              _createTextVNode(" Save Order "),
              (_ctx.isSaving)
                ? (_openBlock(), _createBlock(_component_SpinnerLoader, {
                    key: 0,
                    color: 'white',
                    class: "save-loader"
                  }))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_v_divider),
      (!_ctx.isPrivateSeller)
        ? (_openBlock(), _createBlock(_component_Container, {
            key: 3,
            orientation: "vertical",
            onDrop: _ctx.onDrop
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredArtists, (artist) => {
                return (_openBlock(), _createBlock(_component_Draggable, {
                  key: artist.id
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ArtistCard, {
                      artist: artist,
                      role: _ctx.auth.userRole,
                      draggable: "",
                      onDelete: ($event: any) => (_ctx.showAlert(artist.id)),
                      onMoveUp: ($event: any) => (_ctx.moveUp(artist.id)),
                      onMoveDown: ($event: any) => (_ctx.moveDown(artist.id))
                    }, null, 8, ["artist", "role", "onDelete", "onMoveUp", "onMoveDown"])
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }, 8, ["onDrop"]))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredArtists, (artist) => {
              return (_openBlock(), _createBlock(_component_ArtistCard, {
                key: artist.id,
                artist: artist,
                role: _ctx.auth.userRole,
                draggable: "",
                onDelete: ($event: any) => (_ctx.showAlert(artist.id)),
                onMoveUp: ($event: any) => (_ctx.moveUp(artist.id)),
                onMoveDown: ($event: any) => (_ctx.moveDown(artist.id))
              }, null, 8, ["artist", "role", "onDelete", "onMoveUp", "onMoveDown"]))
            }), 128))
          ])),
      (_ctx.artistsLength.length > _ctx.limit)
        ? (_openBlock(), _createBlock(_component_PaginationComponent, {
            key: 5,
            pageSize: _ctx.pageSize,
            data: _ctx.length,
            "current-page": _ctx.currentPage,
            onPageChanged: _ctx.updatePagination
          }, null, 8, ["pageSize", "data", "current-page", "onPageChanged"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}